import { combineReducers } from '@reduxjs/toolkit';
import data from './dataSlice';
import state from './stateSlice';

const crmCustomers = combineReducers({
  state,
  data,
});

export default crmCustomers;
